<template>
	<div style="margin: 10px;" v-loading="loading">
		<el-card class="box-card">
			<el-row>
				<el-col :span="12">
					<h3 style="text-align: center;margin-bottom:40px">修改密码</h3>
					<el-form ref="form" :model="form" label-width="160px" :rules="rules">
						<el-form-item label="原密码" prop="oldPassword">
							<el-input v-model="form.oldPassword" style="width:100%" type="password"></el-input>
						</el-form-item>
						<el-form-item label="新密码" prop="newPassword">
							<el-input v-model="form.newPassword	" style="width:100%"  type="password"></el-input>
						</el-form-item>
						<el-form-item label="重复密码" prop="repPassword">
							<el-input v-model="form.repPassword" style="width:100%"  type="password"></el-input>
						</el-form-item>
						<el-form-item>
							<input type="button" class="submit" @click="onSubmit('form')" value="提交">
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="12">
					<h3 style="text-align: center;margin-bottom:40px">修改头像</h3>
					<el-form ref="Headform" :model="Headform" label-width="160px" >
						<el-form-item label="头像" prop="head">
						<el-upload
						  class="avatar-uploader"
						  action=""
						:before-upload="beforePic"
						  :show-file-list="false"
						 >
						  <img v-if="imageUrl" :src="imageUrl" class="avatar">
						  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
						</el-form-item>
						<el-form-item>
								<input type="button" class="submit" @click="submitHead" value="提交">
							</el-form-item>
						</el-form>
					</el-form>
					
				</el-col>
			</el-row>
		</el-card>
	</div>
</template>

<script>
	import EditorBar from '../components/editor.vue'
	import request from '../assets/js/request.js'
	import qs from 'qs'
	import bus from '../assets/js/bus.js'
	export default {
		components: {
			EditorBar
		},
		data() {
			return {
				form: {
					account:'',
					oldPassword:'',
					newPassword:'',
					repPassword:''
				},
				rules: {
					oldPassword: [{
						required: true,
						message: '请输入原密码',
						trigger: 'blur'
					}],
					newPassword: [{
						required: true,
						message: '请输入新密码',
						trigger: 'blur'
					}],
					repPassword: [{
						required: true,
						message: '请输入重复密码',
						trigger: 'blur'
					}],
				},
				Headform:{},	
				imageUrl:'',
				headUrl:'',
				loading:false
			}
		},
		mounted() {},
		created() {
			this.getHead()
		},
		computed: {
		   
		    uploadDisabled:function() {
		        return this.imagelist.length >0
		    },
		  
		},
		methods: {
			onSubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						var obj = this;
						obj.$http({
							method: 'post',
							url: 'api/v1/user/info/update/passwd',
							data:{
								oldPassword:this.form.oldPassword,
								newPassword:this.form.newPassword,
								repPassword:this.form.repPassword,
							},
						}).then((res) => {
							if (res.data.status == 200) {
								obj.$message.success('修改成功,请重新登陆！')
								this.$router.push({
									path:'/'
								})
							} else {
								obj.$message.error(res.data.message)
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});

			},
			submitHead(){
				this.loading = true
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/user/info/update/avatar',
					data:{
					avatar:this.headUrl
					},
				}).then((res) => {
					if (res.data.status == 200) {
						obj.loading = false
						obj.$message.success(res.data.message)
						bus.$emit('getHead',1)
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
		getHead(){
				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/user/info/avatar',
				}).then((res) => {
					if (res.data.status == 200) {
						this.imageUrl =this.settings.apiBaseImg+ res.data.data.avatar
						this.headUrl = res.data.avatar
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			//上传图片之前调取接口
			beforePic(file, fileList) {
				let objUrl = file;
				let formData = new FormData();
				formData.append('file', objUrl);
				formData.append('uid', localStorage.getItem('uid'));
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/common/upload',
					data: formData,
				}).then((res) => {
					if (res.status == 200) {
					this.imageUrl  = res.data.data.url
					this.headUrl  = res.data.data.fileName
						obj.$message.success(res.data.message)
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
		}
	}
</script>

<style scoped="scoped">
.disabled .el-upload--picture-card {
    display: none;
}
	/deep/ .el-form-item__label {
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 40px;
	}
	/deep/ .avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	 /deep/ .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	 /deep/ .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 178px;
	    height: 178px;
	    line-height: 178px;
	    text-align: center;
	  }
	 /deep/ .avatar {
	    width: 178px;
	    height: 178px;
	    display: block;
	  }
</style>



// WEBPACK FOOTER //
// src/views/password.vue